// Maps LinkedIn language proficiency codes to user-friendly French labels.
// Source: LinkedIn LanguageProficiency enum.

const LANGUAGE_PROFICIENCY_LABELS: Record<string, string> = {
  ELEMENTARY: "Notions de base",
  LIMITED_WORKING: "Capacité professionnelle limitée",
  PROFESSIONAL_WORKING: "Capacité professionnelle fonctionnelle",
  FULL_PROFESSIONAL: "Capacité professionnelle complète",
  NATIVE_OR_BILINGUAL: "Bilingue ou langue natale",
};

const LANGUAGE_PROFICIENCY_SHORT_LABELS: Record<string, string> = {
  ELEMENTARY: "Notions",
  LIMITED_WORKING: "Pro. limitée",
  PROFESSIONAL_WORKING: "Pro. fonctionnelle",
  FULL_PROFESSIONAL: "Pro. complète",
  NATIVE_OR_BILINGUAL: "Bilingue / natif",
};

function normalize(value: string): string {
  return value.replace(/^LanguageProficiency_/, "").toUpperCase();
}

export function formatLanguageProficiency(value?: string | null): string {
  if (!value) return "";
  const key = normalize(value);
  return LANGUAGE_PROFICIENCY_LABELS[key] ?? value;
}

export function formatLanguageProficiencyShort(value?: string | null): string {
  if (!value) return "";
  const key = normalize(value);
  return LANGUAGE_PROFICIENCY_SHORT_LABELS[key] ?? value;
}
